import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ComplianceStatusPageUI from './ComplianceStatusPageUI.js'

class ComplianceStatusPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      remarksList: null,
      fileUpload: null,
    }
  }

  render() {
    return (
      <ComplianceStatusPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        compliance={this.props.match.params.compliance}
        loan={this.state.loan}
        remarksList={this.state.remarksList}
        fileUpload={this.state.fileUpload}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getFileList(context)

    if (this.props.match.params.compliance === 'ts')
      this.getLoanRemarksTs(context)
    if (this.props.match.params.compliance === 'cp')
      this.getLoanRemarksCp(context)
    if (this.props.match.params.compliance === 'cs')
      this.getLoanRemarksCs(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.compliance === this.props.match.params.compliance)
      return
    let context = this.props.context
    this.getLoan(context)

    if (this.props.match.params.compliance === 'ts')
      this.getLoanRemarksTs(context)
    if (this.props.match.params.compliance === 'cp')
      this.getLoanRemarksCp(context)
    if (this.props.match.params.compliance === 'cs')
      this.getLoanRemarksCs(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getFileList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/compliances/uploadedFileList`,
      cacheKey: CacheKeys.FileList(this.props.match.params.loanId),
      callback: this.getFileListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getFileListCallback = (response) => {
    this.setState({ errorList: response.errorList, fileUpload: response.fileUploadList })
  }

  getLoanRemarksTs(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/term_sheet/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'ts'),
      callback: this.getLoanRemarksTsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanRemarksTsCallback = (response) => {
    this.setState({ errorList: response.errorList, remarksList: response.remarksList })
  }

  getLoanRemarksCp(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/cp/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'cp'),
      callback: this.getLoanRemarksCpCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanRemarksCpCallback = (response) => {
    this.setState({ errorList: response.errorList, remarksList: response.remarksList })
  }

  getLoanRemarksCs(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/cs/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'cs'),
      callback: this.getLoanRemarksCsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanRemarksCsCallback = (response) => {
    this.setState({ errorList: response.errorList, remarksList: response.remarksList })
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.FileList(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanRemarks(loan.loanId, 'ts'))
    CacheManager.removeObject(CacheKeys.LoanRemarks(loan.loanId, 'cp'))
    CacheManager.removeObject(CacheKeys.LoanRemarks(loan.loanId, 'cs'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getFileList(context)
      if (this.props.match.params.compliance === 'ts')
        this.getLoanRemarksTs(context)
      if (this.props.match.params.compliance === 'cp')
        this.getLoanRemarksCp(context)
      if (this.props.match.params.compliance === 'cs')
        this.getLoanRemarksCs(context)
    }
    else {
      this.setState(
        {
          loan: null,
          remarksList: null,
          errorList: null,
        }, () => {
          this.getLoan(context)
          this.getFileList(context)
          if (this.props.match.params.compliance === 'ts')
            this.getLoanRemarksTs(context)
          if (this.props.match.params.compliance === 'cp')
            this.getLoanRemarksCp(context)
          if (this.props.match.params.compliance === 'cs')
            this.getLoanRemarksCs(context)
        }
      )
    }
  }
}

export default withRouter(ComplianceStatusPageSF)
